'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      console.log(`Newsletter subscription: ${email}`);
      setIsSubscribed(true);
      setTimeout(() => {
        setIsSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-2xl p-8 lg:p-12 text-center">
      <div className="max-w-2xl mx-auto">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="EnvelopeIcon" size={32} variant="solid" className="text-white" />
        </div>
        <h2 className="text-3xl lg:text-4xl font-headline font-bold text-white mb-4">
          Stay Updated with Moving Tips
        </h2>
        <p className="text-white/90 text-lg mb-8">
          Get seasonal moving advice, packing tips, and exclusive offers delivered to your inbox
        </p>

        {isSubscribed ? (
          <div className="bg-success text-white py-4 px-6 rounded-lg flex items-center justify-center space-x-2">
            <Icon name="CheckCircleIcon" size={24} variant="solid" />
            <span className="font-semibold">Successfully subscribed! Check your email.</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-6 py-4 rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-accent"
            />
            <button
              type="submit"
              className="bg-accent text-accent-foreground px-8 py-4 rounded-lg font-semibold hover:bg-opacity-90 transition-all duration-base flex items-center justify-center space-x-2 whitespace-nowrap"
            >
              <span>Subscribe Now</span>
              <Icon name="ArrowRightIcon" size={20} variant="solid" />
            </button>
          </form>
        )}

        <p className="text-white/70 text-sm mt-4">
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </div>
  );
};

export default NewsletterSignup;